module.exports = __webpack_public_path__ + "img/copy.1474f7c6.svg";